
/**
 * 
 * This elements displays a progressive count from zero to a given value (number)
 * The following attributes are supported:
 * 
 * - value: an integer to count to
 * - duration: the duration of the count in milliseconds. Optional and defaults to 5000
 * 
 * */

$(function () {
    document.createElement("counter");

    $("counter").each(function (idx, element) {

        var _start = function () {
            var value = $(element).attr("value");
            var duration = $(element).attr("duration");
            duration = duration || 3000;

            if (!value) return;

            var count = 0;
            var $element = $(element);
            var total = parseInt(value);
            var maxTimer = parseInt(duration);
            var millisInterval = 50;
            var steps = Math.round(total / (maxTimer / millisInterval));
            steps = steps < 1 ? 1 : steps;

            var timer = setInterval(function () {
                if (count <= total) {
                    $element.html(count.format(0));
                    count += steps;
                }
                else {
                    $element.html(total.format(0));
                    clearInterval(timer);
                }
            }, millisInterval);
        };

        _start();

        $(this).change(function () {
            _start();
        });
    });
});